import { APP, SELECTOR, setSelector } from '@socialive/common';

const selectApp = () => APP.PORTAL;

setSelector(SELECTOR.APP, selectApp);

export default selectApp;
